import { CallInsightDemoTray } from '@frontend/call-insight-panel';
import { MultiContactsPanel, ManageDevices } from '@frontend/calls-v2';
import { ContactPanel, ContactPanelComponent, ContactPanelTrayComponent } from '@frontend/contact-panel';
import { ContactForm, CustomContactForm } from '@frontend/create-contact-panel';
import { FaxContactFormPanel } from '@frontend/fax';
import { CallDetailsPanel } from '@frontend/phone-panels';
import { SlidePanelType } from '@frontend/slide-panel';
import { WIDTH_DIMS } from '@frontend/design-system';

// The components should be defined in the shared package
export const slidePanels: Partial<
  Record<
    SlidePanelType,
    Record<'modal' | 'panel', JSX.Element> & { cleanupFn?: () => void; size?: keyof typeof WIDTH_DIMS }
  >
> = {
  contact: {
    modal: <ContactPanel Component={ContactPanelTrayComponent} />,
    panel: <ContactPanel Component={ContactPanelComponent} />,
    cleanupFn: ContactPanel.cleanup,
    size: 'smallXL',
  },
  contactForm: {
    modal: <ContactForm />,
    panel: <ContactForm />,
  },
  customContactForm: {
    modal: <CustomContactForm />,
    panel: <CustomContactForm />,
  },
  faxContactForm: {
    modal: <FaxContactFormPanel />,
    panel: <FaxContactFormPanel />,
  },
  multipleContacts: {
    modal: <MultiContactsPanel />,
    panel: <MultiContactsPanel />,
    cleanupFn: MultiContactsPanel.cleanup,
    size: 'smallXL',
  },
  manageDevices: {
    modal: <ManageDevices />,
    panel: <ManageDevices />,
    size: 'medium',
  },
  callDetails: {
    modal: <CallDetailsPanel />,
    panel: <CallDetailsPanel />,
    size: 'medium',
  },
  callInsight: {
    modal: <CallInsightDemoTray />,
    panel: <CallInsightDemoTray />,
    size: 'small',
  },
};
